import { render, staticRenderFns } from "./INSTR.vue?vue&type=template&id=3b7763fd&"
import script from "./INSTR.vue?vue&type=script&lang=js&"
export * from "./INSTR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports